import axios from 'axios';
// eslint-disable-next-line no-unused-vars

import React, { useState, useEffect,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { encryptPayload,decryptResponse } from './CryptoUtil';
import { APP_URL,BATCH_SIZE, withCredentials } from '../App';

const LastCommand = () => {

  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
    const navigate = useNavigate()
  
    const [fileName, setFileName] = useState('');  
    const [file, setFile] = useState(null);
    const [fileSize, setFileSize] = useState(0);
    const fileInputRef = useRef(null);
  
    const [csvContent, setCsvContent] = useState('');    
    const [jsonContent, setJsonContent] = useState(null);
  
    const [incorrectData, setIncorrectData] = useState([]);
    const [correctData, setCorrectData] = useState([]);
    const [correctImeiData, setCorrectImeiData] = useState([]);
  
    const [downloadUrl, setDownloadUrl] = useState(null);
  
    const [showDownloadButton, setShowDownloadButton] = useState(false);

     const [readingTime, setReadingTime] = useState(0);
      const [processTime,setProcessTime]= useState(0)
    
      const [pleasWait ,setPleaseWait] = useState(false)
      const [processBatchWait ,setProcessBatchWait] = useState(false)
    
    
    
      
    
    
    


   
 
     
     
    
     
    
    
    const processUploadedFile = async (selectedFile, correctData) => {
  const file = selectedFile;
  setFile(file);

  if (file) {
    const fileType = file.type;
    if (fileType === 'text/csv') {
      try {
        const userSession = JSON.parse(localStorage.getItem("userSession"));
        const decryptedUser = decryptResponse(userSession.data.payload, userSession.data.transactionId);
        const token = decryptedUser.token;

        // Start processing valid IMEIs
        const imeiList = correctData;

        const allItems = [];
        setPleaseWait(true);

        for (let i = 0; i < imeiList.length; i += BATCH_SIZE) {
          const batch = imeiList.slice(i, i + BATCH_SIZE);

          const batchResponses = await Promise.all(
            batch.map(async (imei) => {
              try {
                const encryptedPayload = encryptPayload({ imei: imei });
                const response = await axios.post(
                  `${APP_URL}devicedetails.php`,
                  encryptedPayload,
                  {
                    withCredentials: withCredentials,
                    headers: {
                      'Content-Type': 'application/json',
                      'X-API-Key': token,
                    },
                  }
                );

                const decryptedData = decryptResponse(
                  response.data.payload,
                  response.data.transactionId
                );

                return decryptedData.items && decryptedData.items.length > 0
                  ? decryptedData.items[0]
                  : null;
              } catch (err) {
                console.error(`Error fetching data for IMEI: ${imei}`, err);
                return null;
              }
            })
          );

          // Filter valid data and add to state
          const validItems = batchResponses.filter((item) => item !== null);
          allItems.push(...validItems);
          setItems((prevItems) => [...prevItems, ...validItems]);
        }

        setPleaseWait(false);
        if (allItems.length === 0) {
          setError('No valid device data found for uploaded IMEIs.');
        }
      } catch (error) {
        console.error("Upload processing failed:", error);
        setError('An error occurred while processing the uploaded file.');
        setPleaseWait(false);
      }
    } else {
      setFile(null);
      setError('Only CSV files are allowed.');
    }
  }
};




     const handleFileUpload =  (event) => {
   
    event.preventDefault()
    const selectedFile = event.target.files[0];
    const file = selectedFile
    setFile(file)
   
       
    setFileName(selectedFile.name);
   
    setFileSize(selectedFile.size);
    const reader = new FileReader();
    const startTime = performance.now();
    reader.onload = (e) => {
    const content = e.target.result;
    const validation = validateCsvContent(content);

    if (validation.isValid) {
      setCsvContent(content);
      setFile(selectedFile);
     
      setError('');
      parseCsv(content);
     
      processUploadedFile(file,validation.correctData)

    } else {
      setError(validation.error);
      setIncorrectData(validation.incorrectData);
      setJsonContent(null);
      setShowDownloadButton(true);

    }
    const endTime = performance.now();
    const timeElapsed = (endTime - startTime).toFixed(2);
    setReadingTime(timeElapsed);
 
    };
    reader.readAsText(selectedFile);

   
  };

  const validateCsvContent = (content) => {
    const lines = content.trim().split('\n').filter(line => line.trim());
   
    const incorrectData = [];
    const correctData =[];
    const firstCell = lines[0].split(',');
    if(firstCell[0].trim().toLowerCase()==="sno" && firstCell[1].trim().toLowerCase()==="imei1") {
    
    for (let i = 1; i < lines.length; i++) {
      const cells = lines[i].split(',').map(cell => cell.trim());
   
      if(cells.length===2){
        for (let j = 1; j < cells.length; j++) {

          
      
          if (!/^\d{15}$/.test(cells[j].trim())) {
            const errorLine = i ;
           // const errorCellIndex = j + 1;
            const errorCellData = cells[j].trim();
            incorrectData.push({
              line: errorLine,
              error: "Invalid Length found in imei, only 15 digits allowed",
              data: errorCellData
            });
          }else{
           
            correctData.push(cells[j].trim())
           
          }  
      }

      }else{
     
        const errorLine = i ;
         // const errorCellIndex = j + 1;
        const errorCellData = cells.join('-');
          incorrectData.push({
            line: errorLine,
            error: "More than two columns found. please check your file",
            data: errorCellData
          });

      
      }


    }
  }else{
    incorrectData.push({
      line: 1,
      error: "Invalid Headers",
      data: "headers not matched"
    });

  }
    if (incorrectData.length > 0 ) {
      handleDownloadIncorrectData(incorrectData);
      return {
        isValid: false,
        error: `CSV contains incorrect format data.`,
        incorrectData: incorrectData
      };
    }else if(correctData.length>0 && incorrectData.length===0){
     
      return {
        isValid : true,
        correctData : correctData
      }
         

    }
    setPleaseWait(true)
    return { isValid: true };
  };

  
  const parseCsv = (content) => {
    const lines = content.split('\n').filter(line => line.trim());
    const data = lines.map(line => line.split(',').map(cell => cell.trim()));
    setJsonContent(JSON.stringify(data, null, 2));
  };

  const handleUploadClick = () => {
    resetComponent()
    fileInputRef.current.click();
  };

    const handleDownloadIncorrectData = (incorrectData) => {
    const csvContent = generateCsvContent(incorrectData);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    setDownloadUrl(url);
  };

  const generateCsvContent = (incorrectData) => {
    const lines = incorrectData.map(error => `${error.line},${error.data},${error.error}`);
    return 'Sno,Incorrect Data,Error Message\n' + lines.join('\n');
  };

 
  const resetComponent = () => {
    setItems('');
    setFileName('');
    setError('');
    setFile(null);
    setFileSize(0);
    setCsvContent('');
    setJsonContent(null);
    setIncorrectData([]);
    setDownloadUrl(null);
    setShowDownloadButton(false);
   
    setReadingTime(0);
    setIncorrectData([])
    setCorrectData([])
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Reset the file input
    }
  };
   
  
  
 

 
    


  return (
    <div>
      <div className="row">
      <div className="col-md-12 grid-margin transparent">
          <div className="row">
            <div className="col-md-5 mb-4 transparent">
              <h2 className="font-weight-bold">Last Command Reports</h2>
            </div>
           
          </div>
        </div>
        <div className='row'>
            
            <div className='col-md-12 grid-margin transparent'>

                <div className="card">
            <div className="card-body">
              <h4 className="card-title">Last Command Reports: Batch Upload</h4>
              <form className="forms-sample" >
                <div className="form-group">
                
                  {/* <label htmlFor="File Upload">File upload</label> */}
                  <input
                    type="file"
                    className="file-upload-default"
                    id="fileInput"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileUpload}
                  />
                 
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control input-sm file-upload-info"
                      disabled
                      placeholder="Upload CSV"
                      value={fileName}
                    />
                    <span className="input-group-append">
                      <button
                        className="file-upload-browse btn btn-primary btn-sm"
                        type="button"
                        onClick={handleUploadClick}
                      >
                        Select File
                      </button>
                    </span>
                  </div>
                </div>
                {error && <p className="text-danger">{error}</p>}
                {file && (
                  <p>
                    File Details : {file.name} ({(fileSize / 1024).toFixed(2)} KB)
                    {readingTime > 0 && `<br/> - Reading time: ${readingTime} ms`}
                  </p>
                )}
                {incorrectData.length > 0 && (
                  <div className="invalid-imei-container">
                    <div className="row d d-flex ">
                      <h4 className="col-md-4 mx-3">Invalid IMEI:</h4>
                      {downloadUrl && (
                        <a
                          className=""
                          href={downloadUrl}
                          download="incorrect_data.csv"
                        >
                          Click here to download
                        </a>
                      )}
                    </div>
                    <p>
                      File size: {(fileSize / 1024).toFixed(2)} KB
                      <span className="mx-2">|</span>
                      Reading time: {readingTime} ms
                    </p>

                   
               
                  </div>
                )}
               
             
              </form>
            </div>
          </div>


            </div>
        </div>
       

        {items.length > 0 && (
          <div className="col-md-12 grid-margin transparent">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped table-borderless">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Action</th>
                        <th>IMEI 1</th>
                        <th>IMEI 2</th>
                        <th>Enrollment Status</th>
                        <th>Registration Status</th>
                        <th>App Version</th>
                        <th>App Type</th>
                        <th>Last Command</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={item.imei1}>
                          <td>{index + 1}</td>
                          <td><button className="btn btn-info btn-sm text-white"
                   onClick={() => {
                    localStorage.setItem("auditImei", item.imei1);
                    window.location.href = "/auditReport"; // Change to your audit page route
                  }} >View Audit </button></td>
                          <td>{item.imei1}</td>
                          <td>{item.imei2}</td>
                          <td>{item.claimstatus}</td>
                          <td>{item.registrationstatus}</td>
                          <td>{item.appversion}</td>
                           <td>{item.apptype}</td>
                          <td>{item.command}</td>
                          <td>{item.createdat}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
        {items.length === 0  && (
          <div className="col-md-12 grid-margin transparent">
            <p>No results found</p>
          </div>
        )}
      </div>
    </div>
  );
};
LastCommand.displayName = "LastCommand"
export default LastCommand;